import PaginaNaoEncontrada from './pagina-nao-encontrada/pagina-nao-encontrada'

export default [
    {
        path: '/pagina-nao-encontrada',
        name: 'pagina-nao-encontrada',
        component: PaginaNaoEncontrada
    }
]